import type { OwlUnpricedPick } from "../../owl/useOwlUnpricedPicks.ts";

export function OwlUnpricedPanel({
  picks,
  loading,
  error,
  onRetry,
}: {
  picks: readonly OwlUnpricedPick[];
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}): JSX.Element {
  const upcoming = [...picks]
    .filter((pick) => Date.parse(pick.kickoff_at) > Date.now())
    .sort((a, b) => Date.parse(a.kickoff_at) - Date.parse(b.kickoff_at));
  return (
    <section className="owl-unpriced" aria-label="Unpriced Picks">
      <h2>Unpriced Picks</h2>
      <p>
        Odds not verified. Check the exact market and current price with your bookmaker before
        staking.
      </p>
      {error ? (
        <div role="alert">
          {error}{" "}
          <button type="button" onClick={onRetry}>
            Retry
          </button>
        </div>
      ) : loading ? (
        <p role="status">Loading picks...</p>
      ) : upcoming.length === 0 ? (
        <p>No unpriced picks published for this session.</p>
      ) : (
        <ul>
          {upcoming.map((pick) => (
            <li key={pick.id}>
              <div>
                <strong>
                  {pick.home} v {pick.away}
                </strong>
                <div className="owl-unpriced-meta">
                  {pick.league} ·{" "}
                  <time dateTime={pick.kickoff_at}>
                    {new Intl.DateTimeFormat("en-GB", {
                      timeZone: "Africa/Accra",
                      day: "numeric",
                      month: "short",
                      hour: "2-digit",
                      minute: "2-digit",
                    }).format(new Date(pick.kickoff_at))}{" "}
                    Accra
                  </time>
                </div>
              </div>
              <div>
                <strong>{pick.selection}</strong>
                <div className="owl-unpriced-meta">{pick.market}</div>
              </div>
              <span className="owl-unpriced-meta">Odds not verified</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
